import type { LucideIcon } from 'lucide-react'
import type { BrandPromise } from '@/types'

import {
    Clock,
    Gem,
    HeartHandshake,
    Leaf,
    ShieldCheck,
    Sparkles
} from 'lucide-react'
import { cms } from '@/lib/cms'

interface PromiseGridProps {
    promises: Array<BrandPromise>
}

const ICONS: Record<string, LucideIcon> = {
    sparkles: Sparkles,
    shield: ShieldCheck,
    leaf: Leaf,
    clock: Clock,
    gem: Gem,
    heart: HeartHandshake
}

export const PromiseGrid = ({ promises }: PromiseGridProps) => (
    <div className='grid gap-5 sm:grid-cols-2 lg:grid-cols-4'>
        {promises.map((item, index) => {
            const Icon = ICONS[item.icon] ?? Sparkles

            return (
                <article key={item.id} className='relative rounded-3xl border border-border/70 bg-card p-7'>
                    <span className='absolute top-6 right-7 font-heading text-4xl font-semibold text-gold-200' aria-hidden='true'>
                        {String(index + 1).padStart(2, '0')}
                    </span>
                    <span className='flex size-12 items-center justify-center rounded-2xl bg-emerald-50 text-emerald-700'>
                        <Icon className='size-6' />
                    </span>
                    <h3 className='mt-6 font-heading text-2xl font-semibold text-navy-900'>
                        <span data-mdlfy-cms={cms('brand_promises', item.id, 'title')}>{item.title}</span>
                    </h3>
                    {item.description && (
                        <p data-mdlfy-cms={cms('brand_promises', item.id, 'description')} className='mt-2 text-sm leading-relaxed text-muted-foreground'>
                            {item.description}
                        </p>
                    )}
                </article>
            )
        })}
    </div>
)
